<template>
    <pie-chart :chartData="chartComputedData" :options="options"></pie-chart>
</template>

<script>
import {PieChart} from "vue-chart-3";
import {computed} from "vue";

export default {
    name: 'SurveyChart',
    components: {
        PieChart,
    },
    props: {
        chartData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {

        const chartComputedData = computed(() => ({
            labels: props.chartData.labels,
            datasets: props.chartData.datasets.map((dataset) => {
                return {
                    ...dataset,
                    hoverOffset: 4,
                }
            }),
        }));

        const options = {
            maintainAspectRatio: true,
            plugins: {
                legend: {
                    display: false,
                    position: 'right'
                }
            }
        };

        return {
            chartComputedData,
            options,
        };
    }
}
</script>
